import React from 'react';
import '../HomePage.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Left Section */}
                <div className="footer-left">
                    <h3>About Us</h3>
                    <p>
                        We are dedicated to providing professional counselling services to help individuals achieve their personal and career goals.
                    </p>
                    <p>© 2025 The Ideal Pursuits.</p>
                </div>

                {/* Middle Section */}
                <div className="footer-middle">
                    <h3>Quick Links</h3>
                        {/* <p><a href="/about">About</a></p>
                        <p><a href="/services">Services</a></p>
                        <p><a href="/contact">Contact Us</a></p>
                        <p><a href="/faq">FAQ</a></p> */}
                        <p><a href="/#/terms-and-conditions">Terms & Conditions</a></p>
                        <p><a href="/#/privacy-policy">Privacy Policy</a></p>
                        <p><a href="/#/refund-cancellation-policy">Refund and Cancellation Policy</a></p>
                </div>

                {/* Right Section */}
                <div className="footer-right">
                    <h3>Contact Us</h3>
                    <p>
                        Email: Saranraj@idealpursuits.co.in<br />
                        Phone: +91 89396 26189<br />
                        7/21, Jaganathapuram, 4th street, Chetpet, Chennai-600031
                    </p>
                    {/* <p>Follow us on social media:</p>
                    <div className="social-icons">
                        <a href="#"><i className="fab fa-facebook-f"></i></a>
                        <a href="#"><i className="fab fa-twitter"></i></a>
                        <a href="#"><i className="fab fa-instagram"></i></a>
                        <a href="#"><i className="fab fa-linkedin-in"></i></a>
                    </div> */}
                </div>
            </div>
        </footer>
    );
};

export default Footer;
